import { Metafields, Product, ProductTypes } from '@/types/ecommerce.types';
import { handleizeProductType } from '@/utils/utils';
import getProductDescription from '@/utils/getProductDescription';

const getProductDescriptionItems = (
  product: Product,
  shopMetafields?: Metafields
): { key: string; value: string }[] => {
  const productType = handleizeProductType(product?.productType);

  if (!productType || [ProductTypes.GIFTCARDS, ProductTypes.TEDDYBEAR].includes(productType)) {
    return [];
  }

  const { productSize, mount, color, printSize, description, configuration } =
    getProductDescription(product, shopMetafields);

  const items = [];

  if (
    configuration &&
    [ProductTypes.GALLERY, ProductTypes.DESIGNSERVICE, ProductTypes.PUZZLE].includes(productType)
  ) {
    items.push({
      key: 'product-configuration',
      value: configuration,
    });
  }

  if (
    mount &&
    ![
      ProductTypes.MAGNET,
      ProductTypes.MUG,
      ProductTypes.ORNAMENT,
      ProductTypes.PUZZLE,
      ProductTypes.POUCH,
      ProductTypes.STEELBOTTLE,
    ].includes(productType)
  ) {
    items.push({
      key: 'product-mount',
      value: mount,
    });
  }

  if (
    productSize &&
    ![
      ProductTypes.MAGNET,
      ProductTypes.METAL,
      ProductTypes.GLASSPRINT,
      ProductTypes.GLOSSWOODPRINT,
      ProductTypes.ACRYLICSTANDOFF,
      ProductTypes.ACRYLICBLOCK,
      ProductTypes.PUZZLE,
      ProductTypes.POUCH,
      ProductTypes.ACRYLICDESKPRINT,
      ProductTypes.METALDESKPRINT,
    ].includes(productType)
  ) {
    items.push({
      key: 'product-size',
      value: productType === ProductTypes.GALLERY ? `${productSize} ${description}` : productSize,
    });
  }

  if (printSize && ![ProductTypes.GALLERY, ProductTypes.DESIGNSERVICE].includes(productType)) {
    items.push({
      key: 'print-size',
      value: printSize,
    });
  }

  if (
    color &&
    [
      ProductTypes.BLACKLABEL,
      ProductTypes.FRAMEDCANVAS,
      ProductTypes.MUG,
      ProductTypes.PICTURE,
      ProductTypes.GALLERY,
      ProductTypes.POSTER,
    ].includes(productType)
  ) {
    items.push({
      key: 'product-color',
      value: color,
    });
  }

  return items;
};

export default getProductDescriptionItems;
